import filesUrl from 'mk/common/filesUrl';
import { blogsProfileUrl } from 'mk2/apps/blogs/urls';
import { BrandDaysCampaignEntity } from 'mk2/apps/forum/schemas';
import { AvatarImg } from 'mk2/components/AvatarImg';
import { ImgVarHeight } from 'mk2/components/ImgVarHeight';
import { Link } from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './BrandDaysCampaignBanner.mscss';

interface OwnProps {
    brandDaysCampaign: BrandDaysCampaignEntity;
    brandDaysCampaignGreetingText: string;
}

export class BrandDaysCampaignBanner extends React.PureComponent<OwnProps> {

    public render() {
        const { brandDaysCampaign, brandDaysCampaignGreetingText } = this.props;

        return (
            <div className={styles.BrandDaysCampaignBanner}>
                {brandDaysCampaign.user && (
                    <Link
                        className={styles.BrandDaysCampaignBanner__avatar}
                        to={url(blogsProfileUrl, { username: brandDaysCampaign.user.username })}
                    >
                        <AvatarImg user={brandDaysCampaign.user} size={150}/>
                        <ImgVarHeight
                            className={styles.BrandDaysCampaignBanner__avatar__logo}
                            src={filesUrl + brandDaysCampaign.logoSrc}
                            imgWidth={brandDaysCampaign.logoWidth}
                            imgHeight={brandDaysCampaign.logoHeight}
                            width={150}
                        />
                    </Link>
                )}
                <div
                    className={styles.BrandDaysCampaignBanner__greeting}
                    dangerouslySetInnerHTML={{ __html: brandDaysCampaignGreetingText }}
                />
            </div>
        );
    }
}
